namespace $ {

	export function $shm_hitalama_inc_name( names: readonly string[], base: string ) {
		const used = new Set<number>()
		const base_regexp = $mol_regexp.from( base ).source

		for( const name of names ) {
			const match = name.match( new RegExp( `^${ base_regexp } (\\d+)$` ) )
			if( !match ) continue

			used.add( Number( match[1] ) )
		}

		for( let index = 1; ; ++index ) {
			if( used.has( index ) ) continue
			return `${ base } ${ index }`
		}
	}

}
